const initialState = {
    redux: {
        module: "inspection",
    },
    menu: {},
}

export default initialState
